import { GlobalRxStores } from '../../../common/reactiveX/globalRxStores.js';
import { contentTypes } from '../config/contentTypes.js';
export function decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    const { value } = textArea;
    textArea.remove();
    return value;
}
export function timestampToDatetimeLocale(timestamp) {
    let timestampMilliseconds;
    if (timestamp) {
        timestampMilliseconds = timestamp * 1000;
    }
    else {
        timestampMilliseconds = new Date().getTime();
    }
    const date = new Date(timestampMilliseconds);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
}
export function queryProperties(config) {
    var _a;
    return ((_a = config.queryProperties) === null || _a === void 0 ? void 0 : _a.map((q) => `c.${q}`).join()) || '';
}
export async function getArticles(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/articles?properties=c.id,c.title,c.slug,c._legacyId,c.type,c.client,c.language,c.region,c.image&status=published`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getCollateral(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/collateral?properties=c.id,c.title,c.slug,c._legacyId,c.type,c.client,c.language,c.region,c.image&status=published`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getAuthors(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/coaches?properties=c.id,c.name`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getCategories(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/categories?properties=c.id,c.title,c.parentId,c.client,c.region,c.language,c.type,c.slug,c._legacyId`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getClients(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/hubs`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getMilestones(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/milestones?properties=c.id,c.title,c.slug,c.scoringLevel,c._legacyIdc.client,c.language,c.region,c._legacyId&status=published`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getVersions(blueUser, config, document) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/${config.endpoint}/${document.slug}`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getMedia(blueUser) {
    var _a, _b;
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const query = ((_b = (_a = contentTypes
        .find(c => c.type === 'media')) === null || _a === void 0 ? void 0 : _a.queryProperties) === null || _b === void 0 ? void 0 : _b.map((q) => `c.${q}`).join()) || '';
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/media?properties=${query}`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getTags(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/tags?properties=c.id,c.title,c.slug,c.type`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getRafpressListing(blueUser, endpoint, properties) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/${endpoint}?properties=${properties}`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export async function getSnippets(blueUser) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${blueUser.accessToken}`);
    const results = await fetch(new Request(`${process.env.RAFPRESS_API_URL}/snippets?properties=c.id,c.slug,c.region,c.language,c.title`), { headers });
    if (results.ok || results.status === 200) {
        return [...(await results.json())];
    }
    return [];
}
export function handlePropertyDispatch(that, eventName, name, value) {
    that.dispatchEvent(new CustomEvent(eventName, {
        detail: { name, value },
        bubbles: true,
        composed: true,
    }));
}
const ROLE_CONFIG = {
    admin: {
        status: [
            { label: 'Draft', value: 'draft' },
            { label: 'Pending', value: 'pending' },
            { label: 'Publish', value: 'published' },
        ],
    },
    editor: {
        status: [
            { label: 'Draft', value: 'draft' },
            { label: 'Pending', value: 'pending' },
            { label: 'Publish', value: 'published' },
        ],
    },
    user: {
        status: [
            { label: 'Draft', value: 'draft' },
            { label: 'Preview', value: 'preview' },
            { label: 'Request Review', value: 'approvalRequested' },
        ],
    },
};
export const cmsAuthLevel = () => {
    var _a, _b;
    const store = GlobalRxStores.getDefaultStore();
    const authGrants = (_a = store.behaviorSubjectsByKey.get('authGrants')) === null || _a === void 0 ? void 0 : _a.getValue();
    const role = (_b = authGrants === null || authGrants === void 0 ? void 0 : authGrants.cms) === null || _b === void 0 ? void 0 : _b.role;
    if (!role || !ROLE_CONFIG[role])
        return null;
    return { role, ...ROLE_CONFIG[role] };
};
//# sourceMappingURL=helpers.js.map